import { AxiosError } from 'axios';
import { KeyValueResponse } from '../../api';
import {
  ExamRegistrationType,
  ExamType
} from '../../api/candidate/exam/model';
import { GET_EXAM_TYPE_URL } from '../../constants/apiUrls';
import {
  GET_EXAM_TYPE_QUERY_KEY
} from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import { FileProcessingState } from '../../models/File';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ExamTypesResponse {
  uuid: string;
  examType: {
    code: ExamType;
    description: string;
  };
  lastUpdatedTime: string;
  examRegistrationType: ExamRegistrationType;
  fileUuid: string;
  fileStatus: FileProcessingState;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: KeyValueResponse[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetExamTypes = ({ onSuccess, onError }: Input = {}) => {
  const getExamTypes = async () => {
    const res = await axiosClient.get<KeyValueResponse[]>(GET_EXAM_TYPE_URL);
    return res.data;
  };

  return useCustomQuery([GET_EXAM_TYPE_QUERY_KEY], getExamTypes, {
    onSuccess,
    onError,
  });
};
